import type { Theme } from "../types";
import { THEMES } from "../types";
import { isNil } from "lodash-es";
import logger from "./logger";

export const resolveTheme = (name: string): Theme => {
  const themeByName = Object.values(THEMES).find((theme) => theme.name === name);
  if (!isNil(themeByName)) {
    return themeByName;
  }

  // Fallbacks, these are old color names still used in the `Forms` service
  if (name === "Dark") {
    return THEMES.Blue;
  } else if (name === "Gold") {
    return THEMES.Brown;
  } else {
    logger.warn("Failed to resolve theme with name", name);
    return THEMES.Default;
  }
};
